module.exports = __webpack_public_path__ + "238069b31248d534b8d9cdd6c5f90b9a.png";